import {FC} from 'react'

import {FormikDropzone} from '@/components/common/dropzone/FormikDropzone'
import {useTrademarkVerificationContent} from '@/content/trademarkVerification'
import {useTranslation} from '@/i18n'

export const TrademarkDropzone: FC<React.PropsWithChildren<unknown>> = () => {
  const {t} = useTranslation()
  const {supportedFormats} = useTrademarkVerificationContent().dropzone

  const accept = {'image/*': []}

  return (
    <div data-test="trademarkDropzone">
      <FormikDropzone name="file" accept={accept} supportedFormatsText={t(supportedFormats)} />
    </div>
  )
}
